module.exports = __webpack_public_path__ + "static/media/preventivostickets-06-verde.86bf3db1.svg";